import React, { useState } from 'react'
import styled from 'styled-components'
import { IconMoreLine, IconSpace } from './UiIcons'

const Agg = styled.div`
    box-sizing: border-box;
    margin: 0;
    padding: 3px 0 !important;

    /*&:not(:last-child)::after {
        content: ', ';
    }*/

    &[data-with-separator='true'][data-last='false']:after {
        content: ', ';
    }
`

const LIMIT_DEFAULT = 2

type IUiMoreTextInfoProps = {
	value: Array<React.ReactNode>
	withSeparator?: boolean
	limitCollapsed?: number
}

export const UiMoreTextInfo = ({
	value,
	withSeparator = true,
	limitCollapsed = LIMIT_DEFAULT
}: IUiMoreTextInfoProps) => {
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const limit = limitCollapsed && limitCollapsed > 0 ? limitCollapsed : LIMIT_DEFAULT

	if (!(value && value.length)) {
		return null
	}

	const valueFiltered = value.filter(
		(item) => typeof (item) === 'string' ? !!item?.trim() : !!item
	)

	return <div>
		{
			valueFiltered.slice(0, limit).map((_, i, arr) => {
				return !!_ && <Agg key={i}
													 data-with-separator={withSeparator}
													 data-last={isOpen ? false : arr.length - 1 === i}
				>
					{_}
				</Agg>
			})
		}

		{
			valueFiltered.length > limit && !isOpen ? (
				<>
					<button
						//className="icon remix-icon border-0 rounded-circle text-center bg-primary-transparent"
						className="more-text-button remix-icon border-0 text-center bg-transparent"
						onClick={(event: React.MouseEvent) => setIsOpen(true)}
					>
						<IconMoreLine/>
					</button>
				</>
			) : null
		}

		{
			valueFiltered.length > limit && isOpen ? (
				valueFiltered.slice(limit, valueFiltered.length).map((_, i, arr) => {
					return !!_ && <Agg key={i}
														 data-with-separator={withSeparator}
														 data-last={arr.length - 1 === i}
					>
						{_}
					</Agg>
				})
			) : null
		}

		{
			valueFiltered.length > limit && isOpen ? (
				<button className="more-text-button remix-icon border-0 text-center bg-transparent"
				        onClick={(event: React.MouseEvent) => setIsOpen(false)}
				>
					<IconSpace/>
				</button>
			) : null
		}
	</div>
}